import * as yup from 'yup'
import { TFunction } from 'react-i18next'
import { useYupFields } from 'hooks/forms/useYupFields'
import { PostLoginReq } from 'types/authentication/PostLoginReq'

export const Login2faSchema = (t: TFunction<'translation', undefined>) => {
  const { getRequiredYupField } = useYupFields()

  return yup.object<Partial<Record<keyof PostLoginReq, yup.AnySchema>>>({
    otp: getRequiredYupField({ label: t('2fa') })
      .length(6, t('2faWrongLengthError'))
      .matches(/^\d+$/, { message: t('2faNotNumberError') }),
  })
}
